import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=580d17c0&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
import style0 from "./Default.vue?vue&type=style&index=0&id=580d17c0&prod&scoped=true&lang=css"
import style1 from "./Default.vue?vue&type=style&index=1&id=580d17c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d17c0",
  null
  
)

export default component.exports